import { soundManager } from './entities/SoundManager';

// Delegated click includes keyboard activation without sounding on hover,
// text entry, disabled buttons, or the mute control itself.
export function playInterfaceClick(event: { target: EventTarget | null }) {
  if (!(event.target instanceof Element)) return;
  const control = event.target.closest('button, input[type="checkbox"], input[type="radio"], select');
  if (!control || control.closest('[data-audio="off"]') || control.matches(':disabled, [aria-disabled="true"]')) return;
  soundManager.playSFX('click');
}
